//React
import React from 'react'
import {
  Link
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as paymentTicketAction from '../action/paymentTicketAction';
import * as helpAction from '../action/helpAction';
//Material-ui
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
//Add
import moment from 'moment';
//Icon

//Part
import PartUserName from './PartUserName';
import PartPageTitle from './PartPageTitle';


class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sampleList: [],
  	}
  }

  componentDidMount() {
    document.title = '応援チケット - パートナーズ';
    this.props.paymentTicketSenderListGet();
  };

  _renderList(value, index, arr) {
    return (
      <div key={index}>
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
          }}
        >
          <div style={{width:'100px',padding:'5px'}}>
            {
              value.payment_ticket_used ? (
                <span className='blue_icon'>利用済み</span>
              ): (
                <span className='red_icon'>未使用</span>
              )
            }
          </div>
          {
            value.payment_ticket_used ? (
              <div style={{padding:'5px'}}>
                <div>
                  <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                    <PartUserName
                      data={{
                        name: value.userdata_name,
                        sex: value.userdata_sex,
                        size: '1.2em',
                      }}
                    />
                  </Link>
                </div>
                <div>{moment(value.payment_ticket_used_date).format("YYYY年MM月DD日")}</div>
                <div>{value.payment_ticket_day}日チケット</div>
              </div>
            ): (
              <div style={{padding:'5px'}}>
                <div>
                  有料サービス {value.payment_ticket_day}日チケット
                </div>
                <div>使用期限 {moment(value.payment_ticket_expire).format("YYYY年MM月DD日")}迄</div>
                <div>
                  <Button
                    color="primary"
                    variant={ "outlined" }
                    onClick={ () => this.props.helpOpen('id',453) }
                  >
                    プレゼント方法
                  </Button>

                </div>
              </div>
            )
          }


        </div>
        {
          (arr.length - 1 > index) &&
          <Divider />
        }

      </div>
    );
  }

  render() {
    return (
      <div>
        <PartPageTitle
          title={'応援チケット'}
          onback={ '/' }
        />

        <div style={{maxWidth:'480px', margin:'auto'}}>
          {
            (this.props.paymentTicket.sender.list.length > 0) ? (
              <Box boxShadow={2} style={{background:'#FFF'}}>
                {
                  this.props.paymentTicket.sender.list.map(
                    (value, index, arr) => this._renderList(value, index, arr)
                  )
                }
              </Box>
            ): (
              <h2 align='center' style={{padding:'30px 0px'}}>
                取得した応援チケットは<br/>見つかりませんでした
              </h2>
            )
          }
        </div>

        <div align='center' style={{margin:'15px'}}>
          <Button
            color="primary"
            variant={ "outlined" }
            onClick={ () => this.props.helpOpen('category','ticket') }
          >
            「応援チケット」とは？
          </Button>
        </div>
      </div>

    )
  }
}


const mapStateToProps = (state) => {
	return {
		paymentTicket: state.paymentTicket,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...paymentTicketAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
